/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLpInspectionDto } from '../../models/create-lp-inspection-dto';
import { LpInspectionDto } from '../../models/lp-inspection-dto';

export interface NonMemberControllerCreate$Params {
      body: CreateLpInspectionDto
}

export function nonMemberControllerCreate(http: HttpClient, rootUrl: string, params: NonMemberControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
  const rb = new RequestBuilder(rootUrl, nonMemberControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionDto>;
    })
  );
}

nonMemberControllerCreate.PATH = '/api/non-member/inspection/start';
